export default "__VITE_ASSET__7f99ef98__"